import React, { useEffect, useState, useMemo } from "react";
import { Box, Stack, Paper, Typography, IconButton, Tooltip, Button, Drawer, Select, InputLabel, FormControl, MenuItem, FormControlLabel, Checkbox } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import { withTranslation } from "react-i18next";
import { AmountFormat, CheckAccessFunc, formatDate } from "../../../Components/CommonFunctions/CommonFunctions";
import CommonGridHeader, { CommonGridToolBarWithFilterText, CommonGridToolBarWithFilterTextCustom, CommonPatientDetails } from '../../../Components/Common Components/CommonComponents';
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import Loader from '../../../Components/Loader';
import { ImagePaths } from '../../../Utility/ImagePaths';
import { CurrencySymbol } from "../../../Utility/Constants";
import CreditPaymentPopup from "./CreditPaymentPopup";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { DateTime } from "luxon";
import CommonDatePicker from "../../../Components/Common Components/CommonDatePicker";
import { localGetItem } from "../../../Utility/Services/CacheProviderService";

const CorporateIndividualPayement = ({ t, history }) => {
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(30);
    const [isLoader, setIsLoader] = useState(false);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [Providerdetails, setProviderDetails] = useState({
        CorporateName: "",
        noOfBills: 0,
        totalClaimAmount: 0,
        totalOutstanding: 0,
        totalPaidAmount: 0,
    })
    const [paymentPopupOpen, setPaymentPopupOpen] = useState(false);
    const [BulkpaymentPopupOpen, setBulkPaymentPopupOpen] = useState(false);
    const [paymentData, setPaymentData] = useState(null);
    const [PatientList, setPatientList] = useState([])
    const [selectedPatientList, setselectedPatientList] = useState([])
    const [companyData, setcompanyData] = useState(null)
    const [selectedStatus, setselectedStatus] = useState("All");
    const [Filter, setFilter] = useState({
        openFilter: false,
        fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        dateIndex: 1,
    });

    useEffect(() => {
        const CorpData = history?.location?.state?.companyData;
        const fromDate = history?.location?.state?.fromDate == '' ? "" : history?.location?.state?.fromDate;
        const toDate = history?.location?.state?.toDate == '' ? '' : history?.location?.state?.toDate;
        const dateIndex = history?.location?.state?.dateIndex == 0 ? 0 : history?.location?.state?.dateIndex;
        if (CorpData) {
            setFilter(prev => ({
                ...prev,
                fromDate: fromDate,
                toDate: toDate,
                dateIndex: dateIndex
            }));
            setTimeout(() => {
                setcompanyData(CorpData);
            }, 500);
        }
    }, [history]);

    useEffect(() => {
        if (companyData) {
            getPatientCreditList();
        }
    }, [companyData]);

    const getPatientCreditList = async (fromDate = Filter.fromDate, toDate = Filter.toDate, status = selectedStatus) => {
        setIsLoader(true);
        try {
            const encodedCompanyName = encodeURIComponent(companyData?.company_name || '');
            const response = await RestAPIService.getAll(`${Serviceurls.CORPORATE_PROVIDER_INFO_GET}?company_name=${encodedCompanyName}&from_date=${fromDate}&to_date=${toDate || ""}&status=${status === "All" ? "" : status}`);
            if (response.data.status === "success") {
                const list = response.data.data?.map((item, i) => ({ ...item, sno: i + 1 })) || [];
                setProviderDetails(prev => ({
                    ...prev,
                    CorporateName: companyData?.company_name || "",
                    noOfBills: response.data?.total_count || 0,
                    totalClaimAmount: response.data?.total_claimed_amount || 0,
                    totalOutstanding: response.data?.total_pending_amount || 0,
                    totalPaidAmount: response.data?.total_received_amount || 0,
                }));
                setPatientList(list);
            }
        } catch (error) {
            if (error.response?.data?.status === "fail") {
                errorMessage(error.response.data.message);
            }
        } finally {
            setIsLoader(false);
        }
    };

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    };

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    };

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const handleClose = (callAPI) => {
        setPaymentPopupOpen(false);
        setBulkPaymentPopupOpen(false)
        if (callAPI) {
            getPatientCreditList();
        }
    };

    const ClearBulkSelection = () => {
        setSelectionModel([])
    };

    const getCorporateApiUrl = (paymentData, companyName) => {
        const baseUrl = Serviceurls.CORPORATE_BILL_GET;

        if (paymentData?.appointment_id) {
            return `${baseUrl}?appointment_id=${paymentData.appointment_id}&company_name=${companyName}`;
        } else if (paymentData?.ip_admission_id) {
            return `${baseUrl}?ip_admission_id=${paymentData.ip_admission_id}&company_name=${companyName}`;
        } else if (paymentData?.pharmacy_id && paymentData?.id) {
            return `${baseUrl}?ph_bill_id=${paymentData.id}&company_name=${companyName}`;
        } else if (paymentData?.id) {
            return `${baseUrl}?bill_id=${paymentData.id}&company_name=${companyName}`;
        }
    };

    const closeFilter = () => {
        setFilter(prev => ({ ...prev, openFilter: false }));
    }

    const FilterDate = (fromDate, toDate, dateIndex) => {
        setFilter(prev => ({
            ...prev,
            fromDate: fromDate,
            toDate: toDate,
            dateIndex: dateIndex
        }));
    }

    const renderFilterScreen = () => {
        const org_id = JSON.parse(localGetItem("org_id"));
        return (
            <Box component="div" className='eMed_rts_filter_container'>
                <Box component="div" className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t('Filter')}</Typography>
                    <Button
                        emed_tid="vndpay_close"
                        onClick={() => setFilter(prev => ({ ...prev, openFilter: false }))}
                        className='eMed_usrconf_btn'
                    >
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>

                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter_vendor'>
                        {
                            org_id === 707 ? // without restriction date filter works for kkr alone
                                <CommonDatePicker
                                    FromDate={Filter.fromDate}
                                    ToDate={Filter.toDate}
                                    DateIndex={Filter.dateIndex}
                                    SelectedDates={FilterDate}
                                    HideAllMenu={false}
                                /> :
                                <CommonDatePicker
                                    FromDate={Filter.fromDate}
                                    ToDate={Filter.toDate}
                                    DateIndex={Filter.dateIndex}
                                    SelectedDates={FilterDate}
                                    HideAllMenu={true}
                                    OutOfOffice={true}
                                    Past={true}
                                    Future={false}
                                    FromDateOpen="2026-03-22"   // <-- Dont change this date it will affect the Insurace Reports
                                />}
                    </Box>
                    <FormControl sx={{ width: '100%' }} size="small">
                        <InputLabel id="group-select">{t('Status')}</InputLabel>
                        <Select
                            labelId="group-select"
                            id="demo-simple-select"
                            value={selectedStatus}
                            label={t('Status')}
                            onChange={(event) => setselectedStatus(event.target.value)}
                        >
                            <MenuItem value="All">{'All'}</MenuItem>
                            <MenuItem value="pending">{'Pending'}</MenuItem>
                            <MenuItem value="completed">{"Completed"}</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <Stack spacing={2} direction="row" className='eMed_rts_btn' alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small" emed_tid="fil_clear"
                        onClick={() => {
                            const today = DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd');
                            setFilter({
                                fromDate: today,
                                toDate: today,
                                dateIndex: 1,
                                openFilter: false
                            });
                            setselectedStatus("All");
                            getPatientCreditList(today, today, "All");
                        }}
                        id="eMed_Config_btn"
                    >
                        {t("Clear")}
                    </Button>
                    <Button
                        variant='contained'
                        size="small"
                        emed_tid="fil_search"
                        onClick={() => {
                            getPatientCreditList();
                            setFilter(prev => ({ ...prev, openFilter: false }));
                        }}
                        id="eMed_Config_btn"
                    >
                        {t("Search")}
                    </Button>
                </Stack>
            </Box>
        );
    };

    const gridToolBar = () => {
        let TextArray = [
            { label: "From Date", value: formatDate(Filter.fromDate) },
            { label: "To Date", value: formatDate(Filter.toDate) },
        ]
        var ExportData = [];
        PatientList?.length > 0 && PatientList.map((item) => {
            const CorpData = {
                "Patient Name": item?.patient_name,
                "UHID": item?.uhid,
                "Mobile": item?.mobile_no,
                "Admission Detail": item?.module_number,
                "Bill Amount": item?.net_amount,
                "Patient Paid": item?.patient_paid,
                "Received Amount": item?.credit_paid,
                "Outsanding Amount": item?.pending_amount,
            };
            ExportData.push(CorpData);
        });
        return (
            <Box>
                <CommonGridToolBarWithFilterTextCustom data={ExportData} title={"Corporate Provider Information"} FilterTextArray={TextArray} filename={"Corporate Provider Info"} />
            </Box>
        )
    }

    const memoizedCorporateApiUrl = useMemo(() => {
        const payerName = encodeURIComponent(Providerdetails?.CorporateName || '');
        return getCorporateApiUrl(paymentData, payerName);
    }, [paymentData, Providerdetails?.CorporateName]);

    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const handlePaybackClick = (row) => {
        setPaymentData(row);
        setPaymentPopupOpen(true);
    };

    const [selectionModel, setSelectionModel] = useState([]);

    useEffect(() => {
        if (!selectionModel) {
            setselectedPatientList([]);
            return;
        }
        const ids = (selectionModel || []).map((sel) => {
            const byId = PatientList.find((r) => r.id === sel);
            if (byId) return byId.id;
            const bySno = PatientList.find((r) => r.sno === sel);
            if (bySno) return bySno.id;
            return null;
        }).filter(Boolean);
        setselectedPatientList(ids);
    }, [selectionModel, PatientList]);

    const columns = [
        { field: 'sno', headerName: 'S.No', flex: 0.01 },
        {
            field: "patient_name", headerName: 'Patient Details', flex: 0.23,
            renderCell: ({ row }) => (
                <Box component={'div'} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <CommonPatientDetails data={row} disablePhoto={true} />
                </Box>
            ),
            valueGetter: (params) => {
                const name = params.row?.patient_name || "";
                const mobile = params.row?.mobile_no || "";
                const UHID = params.row?.uhid || "";
                return `${name} ${mobile} ${UHID}`;
            }
        },
        {
            field: 'module_number', headerName: 'Admission Details', flex: 0.15,
            renderCell: ({ row }) => (<Box component={'div'}>
                <Tooltip placement='top' title={row?.module_number} arrow>
                    <Box component={'div'}>{row?.module_number ? '...' + row?.module_number?.slice(-13) : "-"}</Box>
                </Tooltip>
            </Box>)
        },
        {
            field: 'net_amount', headerName: `Bill Amount (${CurrencySymbol})`, flex: 0.14,
            renderCell: ({ row }) => AmountFormat(row?.net_amount || 0).replace(CurrencySymbol, "")
        },
        {
            field: 'patient_paid', headerName: `Patient Paid (${CurrencySymbol})`, flex: 0.14,
            renderCell: ({ row }) => AmountFormat(row?.patient_paid || 0).replace(CurrencySymbol, "")
        },
        {
            field: 'credit_paid', headerName: `Received Amount (${CurrencySymbol})`, flex: 0.14,
            renderCell: ({ row }) => AmountFormat(row?.credit_paid || 0).replace(CurrencySymbol, "")
        },
        {
            field: 'pending_amount', headerName: `Outstanding Amount (${CurrencySymbol})`, flex: 0.16,
            renderCell: ({ row }) => (
                <Typography sx={{ color: +row.pending_amount === 0 ? "#1E972A" : "#B82121" }}>
                    {AmountFormat(row?.pending_amount || 0).replace(CurrencySymbol, "")}
                </Typography>
            )
        },
        {
            field: 'status', headerName: 'Status', flex: 0.09,
            renderCell: ({ row }) => (
                <Typography>{row?.pending_amount == 0 ? 'Completed' : 'Pending'}</Typography>
            )
        },
        {
            field: 'actions', headerName: 'Action', flex: 0.07,
            renderCell: ({ row }) => (
                <Tooltip title={t("Payback")} placement="top" arrow>
                    <IconButton disabled={row?.pending_amount == 0 || !CheckAccessFunc("Front Office", "Settlement", "Corporate Provider", "Credit Payment", "SubTab")?.editAccess} size="small" sx={{ borderRadius: "0.3vw", visibility : selectedPatientList?.length === 0 ? 'visible' : "hidden" }} onClick={() => handlePaybackClick(row)}>
                        <img className="emedhub_vendor_img2" src={ImagePaths.Wallet.default} alt="Wallet" style={{ filter: row?.pending_amount == 0 ? 'invert(20%) sepia(0%) saturate(0%) hue-rotate(180deg) brightness(100%) contrast(100%)' : 'none', opacity: 0.8 }} />
                    </IconButton>
                </Tooltip>
            )
        }
    ];

    return (
        <Box className="emedhub__purchase_page">
            <Paper sx={{ marginBottom: '1vw', display:'flex', justifyContent: 'space-between'}}>
                <Button startIcon={<ArrowBackIosNewIcon />} sx={{ textTransform: "capitalize", margin: "0.25vw" }}
                    variant="outlined" onClick={() => history.push({ pathname: "/CreditSettlement/CorporateProvider" })}
                >Back To Provider</Button>
                <Button 
                onClick={()=>{
                    setBulkPaymentPopupOpen(true)
                }}
                disabled={selectedPatientList?.length === 0} variant="contained" size="small" sx={{ textTransform : 'capitalize', margin: "0.25vw"}}>{`Collect All ( ${selectedPatientList?.length || 0} )`}</Button>
            </Paper>
            <Paper>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography style={{ borderBottom: "1px solid #dddddd", fontSize: "0.8dvw", color: "#adadad", padding: "0.7dvw" }}>PROVIDER INFORMATION</Typography>
                    <Tooltip title="Filter" placement='top' arrow>
                        <Button className='eMed_usrconf_btn' onClick={() => { setFilter(prev => ({ ...prev, openFilter: true })) }}>
                            <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                        </Button>
                    </Tooltip>
                </Box>
            </Paper>
            <Paper className="eMed_PharmaVendor_paper" sx={{ height: '5vw' }} elevation={2}>
                <Stack direction="row" sx={{ padding: "1vw" }} spacing={18}>
                    <Stack spacing={1}>
                        <Typography>{t("Corporate Provider")}</Typography>
                        <Tooltip title={(Providerdetails?.CorporateName || '-')} placement="top" arrow>
                            {
                                Providerdetails?.CorporateName && Providerdetails?.CorporateName?.length > 36 ?
                                    <Typography style={{ fontSize: "1rem", fontWeight: "bold" }}>{(Providerdetails?.CorporateName).slice(0, 35) + "..."}</Typography>
                                    :
                                    <Typography style={{ fontSize: "1rem", fontWeight: "bold" }} noWrap>{Providerdetails?.CorporateName || '-'}</Typography>
                            }
                        </Tooltip>
                    </Stack>
                    <Stack spacing={1}>
                        <Typography>{t("No Of Admissions")}</Typography>
                        <Typography style={{ fontSize: "1rem", fontWeight: "bold" }}>{Providerdetails?.noOfBills || 0}</Typography>
                    </Stack>
                    {/* <Stack spacing={1}>
                        <Typography>{t("Total Claim Amount")}</Typography>
                        <Typography style={{ fontSize: "1rem", fontWeight: "bold" }}>{AmountFormat(Providerdetails?.totalClaimAmount || 0)}</Typography>
                    </Stack> */}
                    <Stack spacing={1}>
                        <Typography>{t("Received Amount")}</Typography>
                        <Typography style={{ fontSize: "1rem", fontWeight: "bold" }}>{AmountFormat(Providerdetails?.totalPaidAmount || 0)}</Typography>
                    </Stack>
                    <Stack spacing={1}>
                        <Typography>{t("OutStanding Amount")}</Typography>
                        <Typography style={{ fontSize: "1rem", fontWeight: "bold" }}>{AmountFormat(Providerdetails?.totalOutstanding || 0)}</Typography>
                    </Stack>
                </Stack>
            </Paper>
            <Box sx={{ m: '1vw 0vw', height: '58vh', width: '100%' }}>
                <DataGrid
                    rows={PatientList}
                    columns={columns}
                    pageSize={pageSize}
                    page={page}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Stack direction="row" justifyContent="center" alignItems="center" sx={{ height: "53vh" }}>
                                {t("NoRecordsFound")}
                            </Stack>
                        )
                    }}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    onCellClick={handleCellClick}
                    onRowClick={handleCellClick}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onPageChange={(newPage) => setPage(newPage)}
                    rowsPerPageOptions={[10, 20, 30]}
                    getRowId={(row) => row.sno}
                    hideFooterSelectedRowCount
                    pagination
                    checkboxSelection
                    disableSelectionOnClick={false}
                    selectionModel={selectionModel}
                    isRowSelectable={(params) => params.row.pending_amount}
                    onSelectionModelChange={(newSelection) => setSelectionModel(newSelection)}
                />
            </Box>
            <Loader loaderOpen={isLoader} />
            <Drawer
                anchor={'right'}
                open={Filter.openFilter}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            <CreditPaymentPopup
                open={paymentPopupOpen || BulkpaymentPopupOpen}
                isForBulkPayment={BulkpaymentPopupOpen}
                PatientDataList={PatientList}
                BulkSelectionList={selectedPatientList}
                onClose={handleClose}
                ClearBulkSelection={ClearBulkSelection}
                patientData={paymentData}
                getApiUrl={memoizedCorporateApiUrl}
                postApiUrl={Serviceurls.COMMON_CREDIT_PAYMENT_POST}
                type="Corporate credit"
                errorMessage={errorMessage}
                successMessage={successMessage}
                Editaccess={CheckAccessFunc("front_office", "Credit Settlement", "Corporate Provider", null, "Tab")?.editAccess}
            />

            {errorMsg && <ToastMsg severity='error' msg={errorMsgText} msgPop={msgClose} />}
            {successMsg && <ToastMsg severity='success' msg={successMsgText} msgPop={msgClose} />}
        </Box>
    );
};

export default withTranslation()(CorporateIndividualPayement);
